// extracted by mini-css-extract-plugin
export var breadcrumb = "_i-0";
export var breadcrumbArrow = "_i-1";